const toDoList = {
  path: 'toDoList',
  component: resolve => require(['../../../../pages/user/course/todolist'], resolve)
}

export default toDoList



// WEBPACK FOOTER //
// ./src/router/user/course/todolist/index.js